import React from 'react';
import { Doughnut, Chart } from 'react-chartjs-2';
import CircularProgress from '@material-ui/core/CircularProgress';
var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
  draw: function () {
    originalDoughnutDraw.apply(this, arguments);
    var chart = this.chart.chart;
    var ctx = chart.ctx;
    var width = chart.width;
    ctx.font = '500 32px OpenSans-Regular';
    ctx.textBaseline = 'middle';
    var text = chart.config.data.text,
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = 63;
    ctx.fillText(text, textX, textY);
    ctx.font = '400 15px OpenSans-Regular';
    ctx.textBaseline = 'middle';
    var riskText = chart.config.data.text1,
        riskTextX = Math.round((width - ctx.measureText(riskText).width) / 2),
        riskTextY = 90;
    ctx.fillStyle = '#444444';
    ctx.fillText(riskText, riskTextX, riskTextY);
  }
});

const DoughnutChart = ({
  doughnutData,
  isRiskApiLoading = false
}) => {
  const chartData = JSON.parse(JSON.stringify(doughnutData || {}));
  const hasChartData = !!chartData.datasets[0].data.length; // Show the loading spinner only if the data is not available and the api is loading.

  if (isRiskApiLoading && !hasChartData) {
    return /*#__PURE__*/React.createElement(CircularProgress, null);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, hasChartData ? /*#__PURE__*/React.createElement(Doughnut, {
    data: chartData,
    options: {
      responsive: true,
      cutoutPercentage: 65,
      tooltips: false,
      maintainAspectRatio: false
    }
  }) : /*#__PURE__*/React.createElement("span", null, "No Data."));
};

export default DoughnutChart;